import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  card: {
    position: 'relative',
    width: 450,
    height: 80,
    borderRadius: 4,
    border: `2px dashed ${theme.palette.type === 'dark' ? theme.palette.divider : '#ccc'}`,
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.02)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    cursor: 'default',
    boxSizing: 'border-box',
  },
  label: {
    color: theme.palette.text.hint,
    fontWeight: 500,
    fontSize: 14,
  },
}));

/**
 * Non-clickable placeholder step shown when the layout is unlocked (e.g. after
 * submitting a prompt) but the workflow does not yet have a trigger + action
 * fully configured. Prevents users from opening empty/template nodes.
 */
const SkeletonNode = ({ data }) => {
  const classes = useStyles();
  const stepLabel = data?.stepLabel || 'Step';

  return (
    <div className={classes.card}>
      <Typography className={classes.label} variant="body2">
        {stepLabel}
      </Typography>
    </div>
  );
};

export default SkeletonNode;
